import { render, staticRenderFns } from "./UserSignature.vue?vue&type=template&id=1e54438c&"
import script from "./UserSignature.vue?vue&type=script&lang=ts&"
export * from "./UserSignature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e54438c')) {
      api.createRecord('1e54438c', component.options)
    } else {
      api.reload('1e54438c', component.options)
    }
    module.hot.accept("./UserSignature.vue?vue&type=template&id=1e54438c&", function () {
      api.rerender('1e54438c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/UserSignature.vue"
export default component.exports